/**
 * auth.js – public authentication API helpers
 *
 * These endpoints do NOT require an Authorization header (they are public routes).
 */

import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://vmc-backend-vt2w.onrender.com/api';

const authClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

/**
 * Request a password-reset email.
 * The backend always returns a generic success regardless of whether the
 * email address is registered (anti-enumeration).
 *
 * @param {string} email
 * @returns {Promise<{ status: string, message: string }>}
 */
export const forgotPassword = async (email) => {
  const response = await authClient.post('/auth/forgot-password', { email });
  return response.data;
};

/**
 * Complete the password reset using the one-time token from the email link.
 *
 * @param {string} token        Raw token from the ?token= query param
 * @param {string} newPassword  New plain-text password (min 8 chars)
 * @returns {Promise<{ status: string, message: string }>}
 */
export const resetPassword = async (token, newPassword) => {
  const response = await authClient.post('/auth/reset-password', { token, newPassword });
  return response.data;
};
